export default "__VITE_ASSET__C5eq1R1F__"